import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6900Model } from "../kymw6900.model";

type GetProposalIdResponse = {
  AssociatedUserId: string;
  AssociatedUserName: string;
}[];

/**
 * 提案者一覧を取得するサービス
 *
 * @export GetProposalIdService
 * @class GetProposalIdService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetProposalIdService extends PlessJsonResponderSub<GetProposalIdResponse> {
  private model: KYMW6900Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetProposalIdService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetProposalIdService
   */
  execute(model: KYMW6900Model): void {
    this.model = model;
    this.send('getProposalId', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetProposalIdService
   */
  success(data: GetProposalIdResponse): void {
    // 先頭に空行追加
    const emptyList = [{
      AssociatedUserId: '',
      AssociatedUserName: ''
    }]
    if (data) {
      this.model.proposalUserList = emptyList.concat(data);
    } else {
      this.model.proposalUserList = emptyList;
    }

    if (this.model.isClient()) {
      this.model.searchParams.proposalUserId = this.model.userId();
    }
  }
}
